import * as React from 'react';

import { DataRequestActionTypes } from '../../constants/actionTypes';
import { FormId } from '../../constants/formId';
import FormModal from '../modal/formModal';

import BaseDownloadSummaryForm from './baseDownloadSummaryForm';

// eslint-disable-next-line react/prefer-stateless-function
export class DownloadSummaryForm extends React.Component<{}, { isDst: boolean }> {
  constructor(props: any) {
    super(props);

    this.state = {
      isDst: true,
    };
  }

  handleTimezoneChange = (isDst: boolean) => {
    this.setState({ isDst });
  };

  public render() {
    const { isDst } = this.state;

    return (
      <>
        <FormModal
          formId={FormId.DownloadSummaryForm}
          formTitle="Download Summary"
          submitActionType={DataRequestActionTypes.ClientSummaryClientRequested}
          smallButton
          partialSubmit
          hideButton
          initialValues={{
            dst: isDst,
          }}
        >
          <BaseDownloadSummaryForm formId={FormId.DownloadSummaryForm} onTimezoneChange={this.handleTimezoneChange} />
        </FormModal>
      </>
    );
  }
}
